<p-dialog *ngIf="interaction"
          header="{{ (interaction.id ? 'ADD_INTERACTION_DIALOG.MODIFY_HEADER' : 'ADD_INTERACTION_DIALOG.NEW_HEADER') | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false">
  <form [formGroup]="interactionForm">
    <div class="ui-g m-b-0 service-edit-dialog interaction-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.SUBJECT_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <wsd-extended-input [control]="interactionForm.get('subject')">
              <input pInputText
                     formControlName="subject"/>
            </wsd-extended-input>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.DATE_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <wsd-extended-input [control]="interactionForm.get('date')">
              <p-calendar
                wsdUseUtc
                [showIcon]="true"
                formControlName="date">
              </p-calendar>
            </wsd-extended-input>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.PERSON_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <wsd-extended-input [control]="interactionForm.get('person')">
              <input pInputText
                     formControlName="person"/>
            </wsd-extended-input>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.IMPORTANT_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <p-checkbox formControlName="important"
                        binary="true"
                        class="m-t-10">
            </p-checkbox>
            <i class="fa fa-exclamation"></i>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.CONFIDENTIAL_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <p-checkbox formControlName="confidential"
                        binary="true"
                        class="m-t-10">
            </p-checkbox>
            <i class="fa fa-eye-slash"></i>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_INTERACTION_DIALOG.SUMMARY_LABEL' | translate}}</label>
          </div>
          <div class="ui-g-8 m-b-30">
            <wsd-extended-input [control]="interactionForm.get('summary')">
              <p-editor formControlName="summary"
                        [style]="{'height':'320px'}"
                        styleClass="m-b-15">
              </p-editor>
            </wsd-extended-input>
            <i>{{ 'ADD_INTERACTION_DIALOG.SUMMARY_CAPTION' | translate}}</i>
          </div>
          <div class="ui-g-12" *gsShowIfHasPermission="['ORGANIZATION_INTERACTIONS_UPDATE']">
            <button pButton
                    class="ui-button-success fright"
                    type="button"
                    label="{{ (interaction.$state !== ENTRY_STATES.NEW ? 'ADD_INTERACTION_DIALOG.UPDATE_BUTTON' : 'ADD_INTERACTION_DIALOG.ADD_BUTTON') | translate }}"
                    (click)="save()">
            </button>
            <button pButton
                    *ngIf="interaction.$state !== ENTRY_STATES.NEW"
                    class="ui-button-danger"
                    label="{{ 'ADD_INTERACTION_DIALOG.DELETE_BUTTON' | translate }}"
                    (click)="delete()">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
